export const en = {
  translation: {
    general: {
      now: 'Now',
    },
    navLeft: {
      home: 'home',
      news: 'news',
      projects: 'projects',
      aboutme: 'dwain',
      contact: 'contact'
    },
    home: {
      title: 'DWAIN',
      subTitle: 'professional /../ efficient /../ safe',
      counter: {
        experience: {
          count: '16+',
          title: 'Years of IT experience'
        },
        codeExperience: {
          count: '6000+',
          title: 'Hours of programming experience'
        },
        projects: {
          count: '10+',
          title: 'Successful projects'
        }
      }
    },
    contact: {
      title: 'Get',
      title1: 'in',
      title2: 'contact!',
      subtitle: 'I look forward to starting a project with you or being able to help you with your problems',
      form: {
        inputNameplaceholder: 'Enter your Name',
        inputMailplaceholder: 'Enter valid Email',
        inputTextplaceholder: 'Enter your message',
        enterButton: 'Send'
      }
    },
    me: {
      infoText1: 'Ive been a passionate computer nerd since I was 14 years old. My enthusiasm for technology started early when I built my first websites - very oldschool, pure HTML/CSS. These first steps were the beginning of a journey that led me deep into the world of computer science.',
      infoText2: 'I also came into contact with the topic of IT security early on. Security issues and solving security problems became an essential part of my interests.',
      infoText3: 'What fascinated me right from the start was the challenge of solving problems. For me, there was no problem that could not be solved.',
      infoText4: 'In addition to programming, I also worked intensively with 3D software and image processing. These creative areas not only helped me to develop a wide range of technical skills, but also sharpened my creativity and aesthetic understanding.',
      infoText5: 'Computer games are also one of my hobbies. The combination of problem solving and playful creativity has further fueled my passion for software development. Today, I am a passionate software developer and look forward to developing innovative solutions and mastering complex challenges every day.',
      card: {
        '2018': {
          position: 'Developer',
          text: 'Development & planning of various tools'
        },
        '2016': {
          position: 'Owner',
          text: 'News page about sandbox games'
        },
        '2013': {
          position: 'Owner',
          text: 'Community Fanpage about the MMORPG Blackdesert'
        },
        '2011': {
          position: 'Owner',
          text: 'Community Fanpage about the MMORPG ArcheAge'
        }
      }
    },
    error: {
      title: 'PAGE NOT FOUND'
    },
    'Welcome to React': 'Welcome to React and react-i18next'
  }
}